import React, { Component, Suspense } from "react";
import { reactLocalStorage } from 'reactjs-localstorage';
import { connect } from 'react-redux';
import SideBar from './nav/NavBar';
import { Route, Switch } from "react-router-dom";
import ReduxToastr from 'react-redux-toastr';
import Footer from "../components/footer/Footer";
import Login from './login/Login';
import NotFoundPage from './common/NotFoundPage';
import User from './user';
import Dashboard from './dashboard';
import { Loader } from '../../src/components/common/Loader';
import DesignMaster from './designMaster'
import { showUserData } from '../actions';
import AuthMiddleware from '../AuthMiddleware';
import { isUserLoggedIn } from '../helper/auth';
import RawMaterialMaster from "./material-master";


class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibelPageNotFound: false
    };
  }

  /**
   * @method handlePageNotFound
   * @description Handle the page not found when the url entered is incorrect.
   */
  handlePageNotFound = () => {
    this.setState({
      visibelPageNotFound: true
    });
  };

  /**
   * @method handleUserData
   * @description Method used when refreshing browser then consistency of logged in user.
   */
  handleUserData = () => {
    let userData = reactLocalStorage.getObject("userDetail");
    this.props.showUserData(userData)
  }

  render() {
    return (
      <Suspense fallback={<Loader />}>
        <div>
          {!this.state.visibelPageNotFound && isUserLoggedIn() &&
            <div className="sf-mainwrapper">
              <div className="sf-mainheader">
                <div className="header-menu">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="inner-header main-menu">
                        {/* <a href="javaScript:Void(0);"><img src={require('../assests/images/cir-logo.png')} alt='Cost It Right' /> */}
                        {/* </a> */}

                        <Route
                          path="/"
                          render={props => (
                            <SideBar
                              {...props}
                              isUserLoggedIn={this.props.isUserLoggedIn}
                              logUserIn={this.props.logUserIn}
                              logUserOut={this.props.logUserOut}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          <div className={`blue-box ${!isUserLoggedIn() ? 'before-login' : ''}`}>
            <div className="middleContainer mt-30">
              <Switch>
                <Route path="/login" render={(props) =>
                  <Login
                    {...props}
                    isUserLoggedIn={this.props.isUserLoggedIn}
                    logUserIn={this.props.logUserIn}
                  />
                } />
                <Route exact path="/" render={(props) =>
                  <Login
                    {...props}
                    isUserLoggedIn={this.props.isUserLoggedIn}
                    logUserIn={this.props.logUserIn}
                  />
                } />
                <Route path="/user" component={AuthMiddleware(User)} />
                <Route path="/design-master" component={AuthMiddleware(DesignMaster)} />
                <Route path="/raw-material-master" component={RawMaterialMaster}/>
                <Route
                  render={props => <NotFoundPage {...props}
                    isLoggeIn={false}
                    handlePageNotFound={this.handlePageNotFound}
                  />}
                />
                {/* <Route exact path="/" component={Homepage} /> */}
                {/* <Route exact path="/" component={AuthMiddleware(Dashboard)} /> */}
                {/* <Route path="/" render={(props) =>
                <Login
                  {...props}
                  isUserLoggedIn={this.props.isUserLoggedIn}
                  logUserIn={this.props.logUserIn}
                />
              } /> */}
              </Switch>
            </div>
          </div>
          {
            !this.state.visibelPageNotFound &&
            <div>
              <Route path="/" component={Footer} />
            </div>
          }
          <ReduxToastr
            newestOnTop={false}
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            progressBar
          />
          {this.handleUserData()}
        </div >
      </Suspense >
    )
  }
}

/**
 * @method connect
 * @description connect with redux
* @param {function} mapStateToProps
* @param {function} mapDispatchToProps
*/
export default connect(null, { showUserData })(Main);